<div class="main-wrapper scrollspy-container" *ngIf="isLoading">
    <section class="ppage-payment new-page-payment">
        <div class="container">

            <div class="ytb-car-card-item ">


                <h1 class="section-heading">Please wait while we validate your Email</h1>
                <div class="row">
                    <div class="col-sm-12 col-md-5 col-lg-6">
                        <aside class="sticky-kit sidebar-wrapper carpricecard price-summary">
                            <div class="booking-selection-box ">
                                <div class="content">
                                    <ngx-skeleton-loader count="5"
                                        [theme]="{ width: '60%', 'border-radius': '0', height: '15px', 'margin-bottom': '20px' ,'margin-left': '40px'}">
                                    </ngx-skeleton-loader>
                                </div>
                            </div>
                        </aside>
                    </div>
                </div>
                <div class="row">

                    <div class="col-sm-12 col-md-5 col-lg-6">
                        <aside class="sticky-kit sidebar-wrapper carpricecard price-summary">
                            <div class="booking-selection-box ">
                                <div class="content">
                                    <ngx-skeleton-loader count="5"
                                        [theme]="{ width: '60%', 'border-radius': '0', height: '15px', 'margin-bottom': '10px' ,'margin-left': '40px'}">
                                    </ngx-skeleton-loader>
                                </div>
                            </div>
                        </aside>
                    </div>
                    <div class="col-sm-12 col-md-5 col-lg-6">
                        <aside class="sticky-kit sidebar-wrapper carpricecard price-summary">
                            <div class="booking-selection-box ">
                                <div class="content">
                                    <ngx-skeleton-loader count="5"
                                        [theme]="{ width: '60%', 'border-radius': '0', height: '15px', 'margin-bottom': '10px' ,'margin-left': '40px'}">
                                    </ngx-skeleton-loader>
                                </div>
                            </div>
                        </aside>
                    </div>
                </div>
            </div>
        </div>


    </section>


</div>



<div class="content-wrapper dashboard-box-mcpn p-b" *ngIf="!isLoading">

    <div class="col-md-12 myaccount-table ">


        <div class="alert alert-success alert-dismissible mt-2" role="alert" *ngIf="userNotFoundShowSuccess">
            <button type="button" class="close" data-dismiss="alert">×</button>

            <div class="alert-message">
                <span class="alert-icon">
                    <i  class="fa fa-check-circle" style="font-size:36px"></i>
                </span>
                <span class="ml-2" *ngFor="let msg of userNotFoundMessageInfo.uiSuccessMessge"> {{msg}}</span>
            </div>


        </div>


        <div class="alert alert-warning alert-dismissible" role="alert" *ngIf="userNotFounfShowFail">
            <button type="button" class="close" data-dismiss="alert">×</button>

            

            <div class="alert-message">

                <span class="alert-icon">
                    <i class="fa fa-times text-danger"></i>
                </span>

                <span class="ml-2" *ngFor="let msg of userNotFoundMessageInfo.uiErrorMessage"> {{msg}}</span>
            </div>
        </div>
        <div class="ml-4 text-center"><a class="pl-2 viewdetails" routerLink="/"> Click Here Go Home </a></div>
    </div>
</div>